import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GlueConfigurationService } from './glue-configuration.service';
import { IFooter } from '../models/footer.models';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);
  private readonly baseUrl: string = this.glueConfiguration.getEndpointUrl() + '/navigations/';

  /**
   * Get the footer navigation
   * @returns {Observable<IFooter>}
   */
  getFooterNav(): Observable<IFooter> {
    const url: string = this.baseUrl + 'FOOTER_NAVIGATION';
    return this.http.get<IFooter>(url);
  }

  /**
   * Get the social media footer
   * @returns {Observable<IFooter>}
   */
  getSocialMediaFooter(): Observable<IFooter> {
    const url: string = this.baseUrl + 'SOCIAL_MEDIA_FOOTER';
    return this.http.get<IFooter>(url);
  }
}
